<div class="container">
  <div class="search">
    <coin-v2-text-input
      placeholder="{{ 'main-menu.directs-search' | translate }}"
      matFormFieldClass="shadow"
      icon="search"
      [label]="'general.search' | translate"
      [(ngModel)]="searchEmployee"
      (input)="searchInputChanged()"></coin-v2-text-input>
  </div>

  <ngx-simplebar class="content-container primary-scrollbar-vertical no-space">
    @if (displayedEmployeeList?.length > 0) {
      <div class="directs-overview-scroll-viewport">
        @for (employee of displayedEmployeeList; track employee) {
          <coin-siemens-energy-employee-preview
            class="directs-overview-elements"
            [employee]="employee"
            (click)="goToDocumentCenter(employee)"></coin-siemens-energy-employee-preview>
        }
      </div>
    } @else {
      <p>{{ 'main-menu.no-directs-found' | translate }}</p>
    }
  </ngx-simplebar>
</div>
